export default "/build/images/033-6.png?c7627bfd72903ecd539a310b6d6a9a54";